import React, { useEffect } from 'react';

const PrivacyModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(15, 23, 42, 0.85)',
      backdropFilter: 'blur(8px)',
      zIndex: 9999,
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      padding: '20px'
    }} onClick={onClose}>
      <div style={{
        backgroundColor: '#1e293b',
        borderRadius: '16px',
        width: '100%', maxWidth: '800px',
        maxHeight: '90vh',
        overflowY: 'auto',
        position: 'relative',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        padding: '40px',
        color: '#f8fafc',
        lineHeight: '1.6'
      }} onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} style={{
          position: 'absolute', top: '20px', right: '20px',
          background: 'none', border: 'none', color: '#94a3b8',
          cursor: 'pointer', padding: '8px', borderRadius: '50%',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          transition: 'background-color 0.2s, color 0.2s'
        }} onMouseOver={(e) => { e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)'; e.currentTarget.style.color = '#fff'; }}
           onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#94a3b8'; }}>
          <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        <h2 style={{ fontSize: '2rem', marginBottom: '10px', background: 'linear-gradient(90deg, #fff, #818cf8)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', paddingRight: '30px' }}>
          Política de Privacidade e Conformidade LGPD
        </h2>
        
        <p style={{ color: '#94a3b8', fontSize: '0.9rem', marginBottom: '30px' }}>
          Última atualização: {new Date().toLocaleDateString('pt-BR')}
        </p>

        <div style={{ fontSize: '1rem', color: '#cbd5e1' }}>
          <p style={{ marginBottom: '20px' }}>
            A <strong>CripSYS</strong> tem o compromisso de proteger a privacidade e os dados pessoais de nossos clientes e de seus respectivos consumidores finais. 
            Este documento detalha as nossas melhores práticas de governança de dados e a conformidade obrigatória com a <strong>Lei Geral de Proteção de Dados (LGPD - Lei nº 13.709/2018)</strong> aplicadas ao nosso sistema de ERP.
          </p>

          <h3 style={{ fontSize: '1.25rem', marginTop: '25px', marginBottom: '15px', color: '#a5b4fc' }}>1. Princípios da LGPD Adotados no Sistema</h3>
          <ul style={{ paddingLeft: '20px', marginBottom: '20px', listStyleType: 'disc' }}>
            <li style={{ marginBottom: '10px' }}><strong>Finalidade e Adequação:</strong> A coleta de dados no ERP serve exclusivamente para gestão do estabelecimento, faturamento, emissão de notas e relacionamento com clientes.</li>
            <li style={{ marginBottom: '10px' }}><strong>Minimização:</strong> Coletamos apenas os dados estritamente necessários para as funcionalidades (ex: CPF para emissão de nota, telefone para envio de relatórios).</li>
            <li style={{ marginBottom: '10px' }}><strong>Transparência:</strong> Clientes têm painéis claros sobre os dados armazenados.</li>
            <li style={{ marginBottom: '10px' }}><strong>Segurança:</strong> Criptografia de ponta a ponta, backups e controle rigoroso de acesso.</li>
          </ul>

          <h3 style={{ fontSize: '1.25rem', marginTop: '25px', marginBottom: '15px', color: '#a5b4fc' }}>2. Controle de Acessos e Permissões (Privacy by Design)</h3>
          <p style={{ marginBottom: '20px' }}>
            O ERP da CripSYS foi desenvolvido com o conceito de <em>Privacy by Design</em>. Oferecemos controle hierárquico de acesso, garantindo que apenas usuários autorizados (ex: Gerente, Proprietário) possam visualizar dados sensíveis ou exportar relatórios de clientes.
          </p>

          <h3 style={{ fontSize: '1.25rem', marginTop: '25px', marginBottom: '15px', color: '#a5b4fc' }}>3. Gestão de Consentimento e Direitos do Titular</h3>
          <ul style={{ paddingLeft: '20px', marginBottom: '20px', listStyleType: 'disc' }}>
            <li style={{ marginBottom: '10px' }}><strong>Direito de Acesso e Portabilidade:</strong> Exportação rápida do histórico de dados do cliente.</li>
            <li style={{ marginBottom: '10px' }}><strong>Direito de Exclusão:</strong> Funcionalidade de anonimização ou exclusão definitiva de clientes do banco de dados, ressalvadas as obrigações legais (ex: notas fiscais).</li>
            <li style={{ marginBottom: '10px' }}><strong>Gerenciamento de Marketing:</strong> Opção de "opt-out" em envios de promoções.</li>
          </ul>

          <h3 style={{ fontSize: '1.25rem', marginTop: '25px', marginBottom: '15px', color: '#a5b4fc' }}>4. Segurança da Informação e Armazenamento</h3>
          <ul style={{ paddingLeft: '20px', marginBottom: '20px', listStyleType: 'disc' }}>
            <li style={{ marginBottom: '10px' }}><strong>Criptografia:</strong> Dados em trânsito (SSL/TLS) e dados em repouso.</li>
            <li style={{ marginBottom: '10px' }}><strong>Logs de Auditoria:</strong> Registro de ações críticas realizadas no sistema.</li>
            <li style={{ marginBottom: '10px' }}><strong>Retenção de Dados:</strong> Manutenção apenas pelo tempo necessário para cumprimento de obrigações legais.</li>
          </ul>

          <h3 style={{ fontSize: '1.25rem', marginTop: '25px', marginBottom: '15px', color: '#a5b4fc' }}>5. Papéis de Controlador e Operador</h3>
          <p style={{ marginBottom: '20px' }}>
            O <strong>estabelecimento contratante atua como Controlador</strong> dos dados de seus consumidores, responsável por coletar o consentimento.
            A <strong>CripSYS atua como Operadora</strong>, realizando o processamento exclusivamente para prover as funcionalidades do sistema ERP.
          </p>

          <h3 style={{ fontSize: '1.25rem', marginTop: '25px', marginBottom: '15px', color: '#a5b4fc' }}>6. Contato do DPO</h3>
          <p style={{ marginBottom: '20px' }}>
            Para exercer direitos previstos na LGPD, entre em contato com nosso suporte ou pelo WhatsApp: <a href="https://wa.me/554195211928" target="_blank" rel="noopener noreferrer" style={{ color: '#818cf8', textDecoration: 'none' }}>+55 (41) 9521-1928</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyModal;
